module.exports = __webpack_public_path__ + "grab.feff.cur";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/grab.cur
// module id = ./src/_asset/sources/assets/images/grab.cur
// module chunks = main